module.exports = __webpack_public_path__ + "img/0Q3A8493_L.6f2fb1cb.webp";